import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import { colorContrastLower, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { JSX, PropsWithChildren } from "react"
import { Children, isValidElement } from "react"
import { ListItem } from "./ListItem"
import type { ListItemProps } from "./ListItem"
import { ListItemValue } from "./ListItemValue"

export interface ListProps extends PropsWithChildren {
	/**
	 * The header of the list.
	 */
	header?: string | JSX.Element
}

const ListComponent = (props: ListProps) => {
	const { children, header, ...rest } = props
	const list = (
		<UnorderedList {...(!header && rest)}>
			{Children.map(children, (child) => (isValidElement(child) ? { ...child } : null))}
		</UnorderedList>
	)

	return header ? (
		<div {...rest}>
			<Header>{typeof header === "string" ? <PText weight="semibold">{header}</PText> : header}</Header>
			{list}
		</div>
	) : (
		list
	)
}

const ListItemComponent: (props: ListItemProps) => JSX.Element = ListItem
ListComponent.Item = ListItemComponent

ListComponent.ItemValue = ListItemValue

/**
 * The `List` component can be used to display a collection of related data in a structured way.
 *
 * The List consists of `ListItems` which hold the content of one list row.
 */
export const List = ListComponent

const UnorderedList = styled.ul`
	margin: 0;
	padding: 0;
`

const Header = styled.div`
	padding: 0 0 ${spacingStaticSm};
	margin: 0 0 ${spacingStaticSm};
	border-bottom: 1px solid ${colorContrastLower};
`
